window.io_global_object_name = "IGLOO";
window.IGLOO = window.IGLOO || {
    "bbout_element_id": "ioBB",
    "bb_callback": /*function (bb, complete) {
                    var bb_field = document.getElementById("bb");
                    bb_field.value = bb;
                    alert('Blackbox collected');
                }*/ null,
    "loader": {
        "uri_hook": "iojs",
        "version": "general5"
    }
};